// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'speaker';

export const Component = () => (
  <path d='M17.595 4c.408 0 .725.13.997.392s.408.567.408.96v14.296c0 .393-.136.698-.408.96a1.359 1.359 0 0 1-.997.392c-.317 0-.633-.087-.86-.305l-5.164-4.184H6.906a.913.913 0 0 1-.634-.262.846.846 0 0 1-.272-.61V9.362a.84.84 0 0 1 .272-.61.913.913 0 0 1 .634-.262h4.665l5.163-4.184c.317-.218.634-.305.86-.305L17.596 4Zm.453 15.648V5.35c0-.305-.136-.436-.453-.436-.045 0-.135.043-.317.088l-5.39 4.358h-4.98v6.277h4.982l5.435 4.359c.045.043.136.087.271.087.317 0 .453-.13.453-.436Z' />
);

export const viewBox = '0 0 25 25';
